import axios from 'axios';
import Cookie from 'js-cookie';

const instance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    'Content-Type': 'application/json',
    // 'Access-Control-Allow-Origin': true,
  }
});

instance.interceptors.request.use(
  config => {
      const accessToken = localStorage.getItem('access-token');
      if (accessToken) {
          config.headers.common = { Authorization: `Bearer ${accessToken}` };
      }
      return config;
  },

    error => Promise.reject(error.response || error.message)
);

// `redirecting` guards against multiple concurrent 401s each firing their own
// alert + redirect (e.g. when a page fans out several API calls in parallel).
// Once we decide to send the user back to /login we ignore every further 401.
let redirecting = false;

function forceReLogin() {
  if (redirecting) return;
  redirecting = true;
  localStorage.removeItem('access-token');
  localStorage.removeItem('refresh-token');
  Cookie.remove('access-token');
  if (window.location.pathname !== '/login') {
    // replace() so the browser's back button doesn't bounce the user back
    // onto the broken authenticated page after they re-login.
    window.location.replace('/login');
  }
}

instance.interceptors.response.use(
  response => response,
  async error => {
      const status = error.response?.status;
      const originalRequest = error.config || {};

      if (status === 401 && !originalRequest._retry) {
          originalRequest._retry = true;
          const refreshToken = localStorage.getItem('refresh-token');

          // Try to silently swap a fresh access token in and retry the
          // original request. Only when that fails (or there is no
          // refresh-token to begin with) do we drag the user back to /login.
          if (refreshToken) {
              try {
                  const res = await axios.post(
                      `${process.env.REACT_APP_BACKEND_URL}/auth/refresh`,
                      { refresh_token: refreshToken }
                  );
                  localStorage.setItem('access-token', res.data.payload.token);
                  localStorage.setItem('refresh-token', res.data.payload.refresh_token);
                  Cookie.set('access-token', res.data.payload.token);
                  window.dispatchEvent(new Event('access-token-updated'));
                  originalRequest.headers = originalRequest.headers || {};
                  originalRequest.headers['Authorization'] = `Bearer ${res.data.payload.token}`;
                  return instance(originalRequest);
              } catch (_) {
                  // fall through to forceReLogin
              }
          }

          forceReLogin();
          return Promise.reject(error.response || error.message);
      }

      if (status === 403) {
        window.location.href = '/403';
      }

      return Promise.reject(error.response || error.message);
  }
);

export default instance;
